(function () {
  'use strict';

  var labels = {
    outlaw: { name: 'The Outlaw' },
    gunslinger: { name: 'Gunslinger Kit' },
    duelist: { name: 'Duelist Set' }
  };

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency) || {};
    var rate = Number(currency.rate) || 1;
    var code = currency.active || 'USD';
    var locale = (window.Shopify && window.Shopify.locale)
      ? String(window.Shopify.locale).replace('_', '-')
      : (document.documentElement.lang || 'en-US');
    var amount = (Number(cents) || 0) * rate / 100;
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(amount); }
    catch (ignore) { return code + ' ' + amount.toFixed(2); }
  }

  function clubWanted(scope) {
    try {
      var box = (scope && scope.querySelector('[data-gb-membership] .gb-check'))
        || document.querySelector('[data-gb-membership] .gb-check');
      return !!(box && box.checked);
    } catch (ignore) { return true; }
  }

  function initTimer(root) {
    var output = root.querySelector('[data-gol-timer]');
    if (!output) return;
    var key = 'gol_outlaw_offer_expires_at';
    var duration = 5 * 60 * 1000;
    var endAt = 0;
    try { endAt = Number(window.sessionStorage.getItem(key)) || 0; } catch (ignore) {}

    function restart() {
      endAt = Date.now() + duration;
      try { window.sessionStorage.setItem(key, String(endAt)); } catch (ignore) {}
    }

    function tick() {
      if (!endAt || endAt <= Date.now()) restart();
      var seconds = Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
      output.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function init(root) {
    if (!document.documentElement.classList.contains('gol-offer-on')) return;
    if (!root || root.getAttribute('data-gol-ready') === 'true') return;
    root.setAttribute('data-gol-ready', 'true');

    var sectionId = root.getAttribute('data-section-id');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gol-choice]'));
    var error = root.querySelector('[data-gol-error]');
    var info = root.closest ? root.closest('.product__info-wrapper') : null;
    var productInfo = (root.closest && (root.closest('.product__info-container') || root.closest('quick-add-modal'))) || info;
    var form = document.getElementById('product-form-' + sectionId);
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    var formProperty = null;
    var selected = root.getAttribute('data-gol-default') || 'gunslinger';

    /* Mirrors the live "Blaster Club Special Price" app discount (Blaster Club
       Discount Engine, offer club-extra-5): 5% off, triggered by the membership
       line in the cart, allow-listed per product. The engine floors the discount
       to whole cents, so floor here too or the page is a cent off the cart. */
    var clubPercent = Number(root.getAttribute('data-gol-club-percent'));
    if (!Number.isFinite(clubPercent) || clubPercent < 0) clubPercent = 0;

    if (info) info.classList.add('gol-active');

    function clubCut(base) {
      if (!clubPercent || !clubWanted(productInfo)) return 0;
      return Math.floor(base * clubPercent / 100);
    }

    function stripHostChrome() {
      var host = root.closest ? root.closest('.slide-item') : null;
      if (host) host.classList.add('gol-host-plain');
    }

    /* Mirror the Cyclone offer order inside the product column:
         offer rows -> Blaster Club -> ADD TO CART -> stock note -> Gear Up add-ons
       The club widget has its own placeBelowNote() that drags itself under the
       stock note, so claim it with data-gb-placed before moving it. */
    function placeChrome() {
      if (!productInfo || !submit) return;
      var club = productInfo.querySelector('[data-gb-membership]');
      var gear = productInfo.querySelector('[data-gbgear]');
      var stock = productInfo.querySelector('[data-stock]');
      var note = stock && stock.closest ? stock.closest('p') : null;
      var buttonRow = submit.closest('.product-form__quantity-and-btn');
      var buttonGroup = buttonRow && buttonRow.parentElement;
      var hostForm = (buttonRow && buttonRow.closest('form, .product-form')) || form;

      if (club) {
        club.setAttribute('data-gb-placed', 'true');
        if (buttonRow && buttonGroup && club.parentElement !== buttonGroup) {
          buttonGroup.insertBefore(club, buttonRow);
        }
        club.setAttribute('data-gol-positioned', 'club');
      }

      if (!hostForm || !hostForm.parentNode) return;
      var after = hostForm;
      if (note) {
        if (note.previousElementSibling !== after) {
          after.parentNode.insertBefore(note, after.nextSibling);
        }
        note.setAttribute('data-gol-positioned', 'stock-note');
        after = note;
      }
      if (gear) {
        if (gear.previousElementSibling !== after) {
          after.parentNode.insertBefore(gear, after.nextSibling);
        }
        gear.setAttribute('data-gol-positioned', 'gear');
      }
    }

    function cardFor(value) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-gol-choice') === value) return cards[i];
      }
      return null;
    }

    function priceOf(card) {
      var base = Number(card && card.getAttribute('data-gol-base'));
      if (!Number.isFinite(base)) return null;
      return base - clubCut(base);
    }

    function renderPrices() {
      cards.forEach(function (card) {
        var now = priceOf(card);
        if (now === null) return;
        var compare = Number(card.getAttribute('data-gol-compare'));
        var priceEl = card.querySelector('[data-gol-price]');
        var saveEl = card.querySelector('[data-gol-save]');
        var wasEl = card.querySelector('[data-gol-was]');
        if (priceEl) priceEl.textContent = money(now);
        if (wasEl && Number.isFinite(compare) && compare > now) wasEl.textContent = money(compare);
        if (saveEl && Number.isFinite(compare) && compare > now) saveEl.textContent = money(compare - now);
      });
    }

    /* Point the theme's own add-to-cart form at the selected loadout variant.
       The two kits are hidden products, so the native ATC + cart drawer keep
       working and no custom /cart/add.js path is needed. */
    function variantInput() {
      if (!form) return null;
      return form.querySelector('input[name="id"].product-variant-id')
        || form.querySelector('input[name="id"]');
    }

    /* The Blaster Club snippet only appends the membership line when the form's
       name="id" is one of its data-gb-root-variant-ids. Selecting a kit rewrites
       that id to a hidden bundle variant, so register the kit variants as roots
       or a checked club box would be silently dropped from the add. */
    function registerLoadoutVariantsWithClub() {
      var club = (productInfo && productInfo.querySelector('[data-gb-membership]'))
        || document.querySelector('[data-gb-membership]');
      if (!club) return;
      var ids = [];
      try { ids = JSON.parse(club.getAttribute('data-gb-root-variant-ids') || '[]'); } catch (ignore) { ids = []; }
      if (!Array.isArray(ids)) ids = [];
      var added = false;
      cards.forEach(function (card) {
        var id = Number(card.getAttribute('data-gol-variant'));
        if (id && ids.indexOf(id) === -1) { ids.push(id); added = true; }
      });
      if (added) club.setAttribute('data-gb-root-variant-ids', JSON.stringify(ids));
    }

    function applyVariant(value) {
      var card = cardFor(value);
      var variantId = card && card.getAttribute('data-gol-variant');
      var input = variantInput();
      if (!variantId || !input) return;
      if (input.value !== variantId) input.value = variantId;
    }

    /* Keep the theme's big price block in step with the chosen loadout. */
    function syncMainPrice(value) {
      if (!sectionId) return;
      var block = document.querySelector('.price-' + sectionId);
      if (!block) return;
      var card = cardFor(value);
      var now = priceOf(card);
      if (now === null) return;
      var compare = Number(card.getAttribute('data-gol-compare'));
      var hasCompare = Number.isFinite(compare) && compare > now;
      block.classList.toggle('price--on-sale', hasCompare);
      Array.prototype.forEach.call(block.querySelectorAll('.price-item--sale, .price-item--regular'), function (el) {
        el.textContent = el.classList.contains('price-item--regular') && hasCompare ? money(compare) : money(now);
      });
    }

    stripHostChrome();
    placeChrome();
    window.requestAnimationFrame(placeChrome);
    window.setTimeout(placeChrome, 250);
    window.setTimeout(placeChrome, 1200);

    if (form) {
      formProperty = form.querySelector('input[data-gol-form-property]');
      if (!formProperty) {
        formProperty = document.createElement('input');
        formProperty.type = 'hidden';
        formProperty.name = 'properties[Loadout]';
        formProperty.setAttribute('data-gol-form-property', '');
        form.appendChild(formProperty);
      }
      /* backstop: re-assert the variant id right before the form is posted,
         in case another script rewrote the input after selection */
      form.addEventListener('submit', function () { applyVariant(selected); }, true);
    }

    function select(value, focusCard) {
      if (!labels[value]) return;
      selected = value;
      cards.forEach(function (card) {
        var on = card.getAttribute('data-gol-choice') === value;
        card.classList.toggle('is-selected', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        card.tabIndex = on ? 0 : -1;
        if (on && focusCard) card.focus();
      });
      if (formProperty) formProperty.value = labels[value].name;
      applyVariant(value);
      syncMainPrice(value);
      if (submit) submit.setAttribute('data-gol-loadout', value);
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () { select(card.getAttribute('data-gol-choice'), false); });
      card.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(card.getAttribute('data-gol-choice'), false);
          return;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = cards[(index + 1) % cards.length];
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = cards[(index - 1 + cards.length) % cards.length];
        if (next) {
          event.preventDefault();
          select(next.getAttribute('data-gol-choice'), true);
        }
      });
    });

    function bindClub() {
      renderPrices();
      syncMainPrice(selected);
      registerLoadoutVariantsWithClub();
      var box = (productInfo && productInfo.querySelector('[data-gb-membership] .gb-check'))
        || document.querySelector('[data-gb-membership] .gb-check');
      if (box && !box.__golBound) {
        box.__golBound = true;
        box.addEventListener('change', function () { renderPrices(); syncMainPrice(selected); });
      }
    }

    document.addEventListener('gb-club:toggle', function () { renderPrices(); syncMainPrice(selected); });
    initTimer(root);
    bindClub();
    window.setTimeout(bindClub, 400);
    var defaultChoice = root.getAttribute('data-gol-default') || 'gunslinger';
    if (!labels[defaultChoice]) defaultChoice = 'gunslinger';
    select(defaultChoice, false);
    window.setTimeout(function () { applyVariant(selected); }, 800);
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-gol]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
